import React, { useMemo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ClearingHouseDetail, CrudEventEnum, EntityTypeEnum, WorkflowActions } from 'api'
import { SplitButtonDropdown, ActionItem } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { useModal } from 'view/shared/modal'
import { ClearingHouseEditDialog, ClearingHouseViewDialog } from '../ClearingHouseDialog'
import { Locale, Translation } from 'locale'

interface ClearingHouseActionsButtonProps extends ActionsButtonProps<ClearingHouseDetail> {}

const canEditDetails = (item: ClearingHouseDetail) => item.availableEvents.includes(CrudEventEnum.UPSERT)

export const ClearingHouseActionsButton: React.FC<ClearingHouseActionsButtonProps> = ({ items }) => {
  const { showModal } = useModal()
  const dispatch = useDispatch()

  const viewItems = useMemo(() => items.filter(item => !canEditDetails(item)), [items])
  const editItems = useMemo(() => items.filter(item => canEditDetails(item)), [items])

  const handleEditItemDialog = useCallback(
    (entityId: string) => {
      const correlatedResponseCallback = (workflowId: string) => {
        showModal(<ClearingHouseEditDialog workflowId={workflowId} entityId={entityId} />)
      }

      dispatch(WorkflowActions.createEditWorkflow(EntityTypeEnum.CLEARING_HOUSE, items[0].clearingHouse.id, correlatedResponseCallback))
    },
    [dispatch, items, showModal]
  )

  const handleShowItemDialog = useCallback(
    (entityId: string) => showModal(<ClearingHouseViewDialog entityId={entityId} />),

    [showModal]
  )

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_VIEW_DETAILS),
      onClick: () => handleShowItemDialog(viewItems[0].clearingHouse.id),
      enabled: viewItems.length === 1
    },
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: () => handleEditItemDialog(editItems[0].clearingHouse.id),
      enabled: editItems.length === 1
    }
  ]

  return <SplitButtonDropdown actions={actions} maxButtons={1} />
}
